import React from "react";
// Components
import TableView, { Toolbar, ExportButton } from "Components/TableView";
import { Grid } from "@mui/material";
import Row from "../row";
import InputDate from "Components/InputDate";
import "./styles.scss";

const TableLoginHistory = (props) => {
  const {
    data,
    loading,
    onSearch,
    onChangePage,
    messages,
    onExport,
    nextToken,
    startDate,
    endDate,
    onChangeDate,
    onCloseSelectDate,
    user
  } = props;

  return ( 
    <TableView
      name="table-login-history"
      data={data}
      loading={loading}
      rowsPerPage={25}
      page={1}
      topSpaceSize={358}
      viewType="list"
      messages={messages}
      renderRow={(row) => <Row data={row} messages={messages} user={user} />}
      toolbarContainerClassName="table-toolbar-container"
      total={data.length}
      onChangePage={onChangePage}
      infiniteScroll
      inputSearch={true}
      serverSide
      onChangeRowsPerPage={() => {}}
      onSearch={(text) => onSearch(text?.trim())}
      itemSelector={false}
      placeholder={messages["loginHistory_search_by"]}
      placeholderSearch={messages["search"]}
      renderHeader={() => {
        return (
          <Grid container className="login-history-header">
            <Grid container item xs={3}>
              <span className="login-history-header-label">
                {messages["loginHistoryView_loginTime"]}
              </span>
            </Grid>
            <Grid container item xs={3}>
              <span className="login-history-header-label">
                {messages["loginHistoryView_username"]}
              </span>
            </Grid>
            <Grid container item xs={3}>
              <span className="login-history-header-label">
                {messages["loginHistoryView_ip"]}
              </span>
            </Grid>
            <Grid container item xs={3}>
              <span className="login-history-header-label">
                {messages["loginHistoryView_attempt"]}
              </span>
            </Grid>
          </Grid>
        );
      }}
      moreRowsAvailable={!!nextToken}
    >
      <Toolbar toolbarClassName="table-toolbar">
        <Grid container spacing={1}>
          <Grid item sm={1}>
            <ExportButton onExport={onExport} />
          </Grid>
          <Grid item sm={6}>
            <div className="login-history-input-date">
              <InputDate
                value={startDate}
                valueEnd={endDate}
                onChange={onChangeDate}
                id={"input-date-range"}
                type={"range"}
                maxDate={new Date()}
                onClose={onCloseSelectDate}
              />
            </div>
          </Grid>
        </Grid>
      </Toolbar>
    </TableView>
  );
};

export default TableLoginHistory;
